import type { FC } from "react";
import { usePortfolioRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import { FolderDetailPageLegacy } from "web_myplann/Portfolio/Pages/Documents/FolderDetailPageLegacy";
import { FolderDetailPageRedesign } from "web_myplann/Portfolio/Pages/Documents/FolderDetailPageRedesign";
import { MyPlannLoading } from "web_myplann/Shared/Components/MyPlannLoading";

export const FolderDetailPage: FC = () => {
	const { hasRight: hasPortfolioRight, isPending } =
		usePortfolioRightOptional();

	if (isPending) {
		return <MyPlannLoading />;
	}

	return hasPortfolioRight ? (
		<FolderDetailPageRedesign />
	) : (
		<FolderDetailPageLegacy />
	);
};
